import { Alert, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";
import { AlertTriangle, type LucideIcon } from "lucide-react";
import type React from "react";

export type AlertVariant = "warning" | "destructive" | "info";

const alertStyles: Record<
  AlertVariant,
  {
    backgroundColor: string;
    textColor: string;
    icon: LucideIcon;
  }
> = {
  warning: {
    backgroundColor: "bg-yellow-100",
    textColor: "text-yellow-800",
    icon: AlertTriangle,
  },
  destructive: {
    backgroundColor: "bg-red-100",
    textColor: "text-red-800",
    icon: AlertTriangle,
  },
  info: {
    backgroundColor: "bg-blue-100",
    textColor: "text-blue-800",
    icon: AlertTriangle,
  },
};

type SimpleAlertProps = {
  title: string;
  message: React.ReactNode;
  variant: AlertVariant;
};

export const SimpleAlert = ({ title, message, variant }: SimpleAlertProps) => {
  const styles = alertStyles[variant];
  const Icon = styles.icon;

  return (
    <Alert className={cn("p-4", styles.backgroundColor, styles.textColor)}>
      <AlertTitle className="font-bold flex items-center text-lg">
        <Icon size={24} className="mr-2" style={{ color: styles.textColor }} />
        {title}
      </AlertTitle>
      <div className="p-0 m-0 whitespace-pre-line">{message}</div>
    </Alert>
  );
};
